export interface GetUsersResults extends Array<Item> {}

interface Item {
  _id: number
  name: string
  archived: boolean
  notificationsLastSeen: string
}

export default function getUsers({get}: any): Promise<GetUsersResults> {
  return get(`/users`, {}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/users/getAll.tsx